import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import onClickOutside from 'react-onclickoutside';

class AttachedCalendar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showCalendar: false
        };

        this.toggleCalendar = this.toggleCalendar.bind(this);
        this.close = this.close.bind(this);
        this.pickDate = this.pickDate.bind(this);
    }

    handleClickOutside() {
        this.close();
    }

    close() {
        this.setState({ ...this.state, showCalendar: false });
    }

    toggleCalendar() {
        this.setState({ ...this.state, showCalendar: !this.state.showCalendar });
    }

    pickDate(date) {
        const { onDateChosen } = this.props;
        onDateChosen(date);
        this.close();
    }

    render() {
        const { date, maxDate, component, wrapperClasses, calendarClasses } = this.props;
        const { showCalendar } = this.state;

        return (
            <div className={wrapperClasses}>
                {component(this.toggleCalendar)}
                {showCalendar && (
                    <div className={calendarClasses}>
                        <DatePicker selected={moment(date)} inline onChange={this.pickDate} maxDate={maxDate} />
                    </div>
                )}
            </div>
        );
    }
}

AttachedCalendar.defaultProps = {
    date: undefined,
    component: undefined,
    onDateChosen: undefined,
    wrapperClasses: '',
    calendarClasses: '',
    maxDate: undefined
};
AttachedCalendar.propTypes = {
    date: PropTypes.any,
    component: PropTypes.func.isRequired,
    onDateChosen: PropTypes.func,
    wrapperClasses: PropTypes.string,
    calendarClasses: PropTypes.string,
    maxDate: PropTypes.object
};

export default onClickOutside(AttachedCalendar);



// WEBPACK FOOTER //
// ./src/components/fields/attachedCalendar/index.jsx